module.exports = __webpack_public_path__ + "static/media/trivia-mobile.2898c902.png";